import Vue from 'vue'
import VueRouter from 'vue-router'
import { translate } from '@/i18n'
import { isLoggedIn } from 'axios-jwt'
import Login from '@/views/Login'
import Access from '@/views/AccessDenied'
import {
  PERSONAL_CABINET_OVERVIEW,
  PERSONAL_CABINET_ROLE,
  getIndexPageMobile,
} from './personalCabinet'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'base',
    meta: {
      roles: []
    },
  },
  {
    path: '/transfers',
    name: 'transfers',
    component: () => import('@/views/transfers/Index'),
    redirect: { name: 'transfers-fuel-receipts' },
    children: [
      {
        path: 'fuel-receipts',
        name: 'transfers-fuel-receipts',
        component: () => import('@/views/transfers/FuelReceipts'),
        meta: {
          title: 'Fuel receipts',
          roles: ['general_manager', 'driver']
        }
      },
      // {
      //   path: 'trips',
      //   name: 'transfers-trips',
      //   component: () => import('@/views/transfers/Trips'),
      //   meta: {
      //     title: 'Trips',
      //     roles: ['general_manager', 'driver']
      //   }
      // },
    ]
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import('@/views/clients/Index'),
    redirect: { name: 'authorization-forms' },
    children: [
      {
        path: 'authorization-forms',
        name: 'authorization-forms',
        component: () => import('@/views/clients/AuthorizationForms'),
        meta: {
          title: 'Authorization forms',
          roles: ['general_manager', 'operations_supervisor']
        }
      },
    ]
  },
  {
    path: '/hotel-management',
    name: 'hotel-management',
    component: () => import('@/views/hotelManagement/Index'),
    redirect: { name: 'pos-transactions' },
    children: [
      {
        path: 'pos-transactions',
        name: 'pos-transactions',
        component: () => import('@/views/hotelManagement/POSTransactions'),
        meta: {
          title: 'POS Transactions',
          roles: ['general_manager', 'hotel_reception', 'hotel_reservations']
        }
      },
    ]
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/finance/Index'),
    redirect: { name: 'finance-payments' },
    children: [
      {
        path: 'payments',
        name: 'finance-payments',
        component: () => import('@/views/finance/payments/List'),
        meta: {
          title: 'Payments',
          roles: ['general_manager', 'operations_manager', 'operations_supervisor']
        }
      },
      {
        path: 'payments-create',
        name: 'finance-payments-create',
        component: () => import('@/views/finance/payments/Create'),
        meta: {
          title: 'Payments',
          roles: ['general_manager', 'operations_manager', 'operations_supervisor']
        }
      },
    ]
  },

  {
    path: '/personal-cabinet',
    name: 'employee-personal-cabinet',
    component: () => import('@/views/personalCabinet/Index'),
    redirect: { name: PERSONAL_CABINET_OVERVIEW },
    meta: {
      roles: [PERSONAL_CABINET_ROLE]
    },
    children: [
      {
        path: 'overview',
        name: PERSONAL_CABINET_OVERVIEW,
        component: () => import('@/views/personalCabinet/Overview'),
        meta: {
          title: 'Personal cabinet',
          titleKey: 'overview.salaryEstimate',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'profile',
        name: 'personal-cabinet-profile',
        component: () => import('@/views/personalCabinet/Profile'),
        meta: {
          title: 'Profile',
          titleKey: 'profile.title',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'payslips',
        name: 'personal-cabinet-payslips',
        component: () => import('@/views/personalCabinet/Payslips'),
        meta: {
          title: 'Payslips',
          titleKey: 'payslips.title',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'loans',
        name: 'personal-cabinet-loans',
        component: () => import('@/views/personalCabinet/Loans'),
        meta: {
          title: 'Loans',
          titleKey: 'loans.title',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'advances',
        name: 'personal-cabinet-advances',
        component: () => import('@/views/personalCabinet/Advances'),
        meta: {
          title: 'Advances',
          titleKey: 'advances.title',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'heslb',
        name: 'personal-cabinet-heslb',
        component: () => import('@/views/personalCabinet/Heslb'),
        meta: {
          title: 'HESLB',
          titleKey: 'nav.heslb',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'leave',
        name: 'personal-cabinet-leave',
        component: () => import('@/views/personalCabinet/Leave'),
        meta: {
          title: 'Leave',
          titleKey: 'leave.title',
          roles: [PERSONAL_CABINET_ROLE]
        }
      },
      {
        path: 'medical-reports',
        name: 'personal-cabinet-medical-reports',
        component: () => import('@/views/personalCabinet/MedicalReports'),
        meta: { title: 'Medical reports', titleKey: 'leave.medicalTitle', roles: [PERSONAL_CABINET_ROLE] }
      },
      {
        path: 'requests',
        name: 'personal-cabinet-requests',
        component: () => import('@/views/personalCabinet/Requests'),
        meta: { title: 'Requests', titleKey: 'requests.title', roles: [PERSONAL_CABINET_ROLE] }
      },
      {
        path: 'history',
        name: 'personal-cabinet-history',
        component: () => import('@/views/personalCabinet/Requests'),
        props: { scope: 'history' },
        meta: { title: 'My history', titleKey: 'requests.historyTitle', roles: [PERSONAL_CABINET_ROLE] }
      },
      {
        path: 'requests/:requestId',
        name: 'personal-cabinet-request-detail',
        component: () => import('@/views/personalCabinet/RequestDetail'),
        meta: { title: 'Request details', titleKey: 'requests.detailTitle', roles: [PERSONAL_CABINET_ROLE] }
      },
      {
        path: 'idea',
        name: 'personal-cabinet-idea',
        component: () => import('@/views/personalCabinet/Feedback'),
        props: { kind: 'idea' },
        meta: { title: 'Suggest an idea', titleKey: 'feedback.ideaTitle', roles: [PERSONAL_CABINET_ROLE] }
      },
      {
        path: 'misconduct',
        name: 'personal-cabinet-misconduct',
        component: () => import('@/views/personalCabinet/Feedback'),
        props: { kind: 'misconduct' },
        meta: { title: 'Report misconduct', titleKey: 'feedback.misconductTitle', roles: [PERSONAL_CABINET_ROLE] }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'welcome',
      title: 'Login',
      titleKey: 'auth.logIn',
      roles: []
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword'),
    meta: {
      layout: 'welcome',
      title: 'Forgot password',
      titleKey: 'auth.forgotTitle',
      roles: []
    },
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('@/views/ResetPassword'),
    meta: {
      layout: 'welcome',
      title: 'Set new PIN',
      titleKey: 'auth.newPinTitle',
      roles: []
    },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: Access,
    meta: {
      title: 'Access denied',
      roles: []
    },
  },
  {
    path: '*',
    redirect: { name: 'base' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const checkRoles = (userRoles = [], routeRoles = []) => {
  if (!userRoles.length || !routeRoles.length) return true
  return userRoles.some(role => routeRoles.includes(typeof role === 'string' ? role : role.code))
}

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()
  const userRoles = JSON.parse(localStorage.getItem('userGroups')) || []

  const publicAuthRoutes = ['login', 'forgot-password', 'password-reset']

  if (loggedIn) {
    if (publicAuthRoutes.includes(to.name)) next({ name: getIndexPageMobile(userRoles) || 'base' })
    else if (to.name === 'access-denied' || checkRoles(userRoles, to.meta.roles)) next()
    else next({ name: 'access-denied' })
  } else {
    if (publicAuthRoutes.includes(to.name)) next()
    else next({ name: 'login' })
  }

  if (to.meta.titleKey) {
    document.body.dataset.titleKey = to.meta.titleKey
    document.title = `${translate(to.meta.titleKey)} | Altezza Board`
  } else if (to.meta.title) {
    delete document.body.dataset.titleKey
    document.title = `${to.meta.title} | Altezza Board`
  }
})

export default router
